const isIsoDate = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

const toMonthStartIso = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

export const addMonthsIso = (monthStart, deltaMonths) => {
  if (!isIsoDate(monthStart)) return null;
  const y = Number(String(monthStart).slice(0, 4));
  const m0 = Number(String(monthStart).slice(5, 7)) - 1;
  if (!Number.isInteger(y) || !Number.isInteger(m0)) return null;
  const d = new Date(y, m0 + Number(deltaMonths || 0), 1);
  d.setHours(0, 0, 0, 0);
  return toMonthStartIso(d);
};

export const compareMonthStartIso = (a, b) => String(a || '').localeCompare(String(b || ''));

export const buildMonthRangeInclusive = (startMonth, endMonth, maxMonths = 240) => {
  if (!isIsoDate(startMonth) || !isIsoDate(endMonth)) return [];

  const from = compareMonthStartIso(startMonth, endMonth) <= 0 ? startMonth : endMonth;
  const to = compareMonthStartIso(startMonth, endMonth) <= 0 ? endMonth : startMonth;

  const out = [];
  let cursor = from;
  let guard = 0;
  while (cursor && compareMonthStartIso(cursor, to) <= 0 && guard < maxMonths) {
    out.push(cursor);
    cursor = addMonthsIso(cursor, 1);
    guard += 1;
  }

  return out;
};
